import { useContext } from "react";
import CartModelDisplayContext from "../context/CartModelDisplayContext";

const useCartModelDisplay = () => {
    const cartModelDisplayContext = useContext(CartModelDisplayContext);
    if (!cartModelDisplayContext) {
        throw new Error('CartModelDisplayContext has to be used within <CartModelDisplay.Provider>');
    } else {
        return cartModelDisplayContext
    }
}

export default useCartModelDisplay;